import { curry, assocPath, path, equals } from 'ramda';

export const mapPath = curry((pathToVal, fn, obj) =>
    assocPath(pathToVal, fn(path(pathToVal, obj)), obj)
);

export const localeCompare = (str = '', compareStr = '', options) =>
    str.localeCompare(compareStr, undefined, options);

/**
 * @template T
 * @param {T[]} a
 * @param {T[]} b
 * @returns {boolean}
 */
export const arrayEquals = (a, b) =>
    a.length === b.length && a.every((item, index) => item === b[index]);
